
import { VIcon } from "vuetify/lib";

export default VIcon.extend({});
